/* Iceman 2026 商品卡：手機左右滑看第二張圖。
   卡片快進畫面就先載第二張（它在橫向捲動區裡，瀏覽器的延遲載入不會自己載），滑過去不會空白。 */
(function () {
  if (window.__icmCard) return;
  window.__icmCard = 1;
  if (!window.matchMedia || !matchMedia('(hover: none)').matches) return;
  var SEL = '.icm-pc:not(.icm-pc--rail) .icm-pc__img.has-alt';
  function eager(el) {
    var a = el.querySelector('.icm-pc__alt');
    if (a && a.getAttribute('loading') !== 'eager') a.setAttribute('loading', 'eager');
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (list) {
      list.forEach(function (x) { if (x.isIntersecting) { eager(x.target); io.unobserve(x.target); } });
    }, { rootMargin: '300px 0px' });
    document.querySelectorAll(SEL).forEach(function (el) { io.observe(el); });
  }
  document.addEventListener('touchstart', function (e) {
    var el = e.target.closest && e.target.closest(SEL);
    if (el) eager(el);
  }, { passive: true, capture: true });
})();
